import {createSlice} from "@reduxjs/toolkit";

export interface PatientsState {
    allPatientsStart: boolean,
    allPatients: any[],
    allPatientsFailed: boolean
}

const initialState: PatientsState = {
    allPatientsStart: false,
    allPatients: [],
    allPatientsFailed: false
}

const patientsSlice = createSlice({
    name: "patients",
    initialState: initialState,
    reducers: {
        fetchAllPatientsStart: (state) => {
            state.allPatientsStart = true;
            state.allPatients = [];
            state.allPatientsFailed = false
        },
        fetchAllPatientsSuccess: (state, action) => {
            state.allPatientsStart = false;
            state.allPatients = action.payload;
            state.allPatientsFailed = false
        },
        fetchAllPatientsFailed: (state) => {
            state.allPatientsStart = false;
            state.allPatients = [];
            state.allPatientsFailed = true
        }
    },
    extraReducers: (builder) => {
        // ITAM-2622 (3.6): patient records must not survive an auth or persona
        // boundary. A token refresh dispatches `loginSuccess`, never
        // `auth/logout`, hence the second action type.
        builder.addCase("auth/logout", () => initialState);
        builder.addCase("auth/personaExit", () => initialState);
    }
});

export const patientsActions = patientsSlice.actions;


export default patientsSlice;